<template>
  <div>
    <draggable v-model="sortedQuestions" @end="endDragQuestion">
      <transition-group class="questions">
        <QuestionCard
          v-for="(i, index) in sortedQuestions"
          :key="i.id"
          v-bind="$props"
          class="questions__card"
          :item="i"
          :index="index"
          :show-fav-controls="true"
          :show-index="true"
          :show-footer="false"
          :show-controls="false"
          @product-click="onProductClick"
        ></QuestionCard>
      </transition-group>
    </draggable>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import draggable from 'vuedraggable'
import QuestionCard from './QuestionCard.vue'

export default {
  components: {
    draggable,
    QuestionCard,
  },
  data() {
    return {
      sortedQuestions: [],
    }
  },
  computed: {
    ids() {
      const ids = []
      for (let i = 0; i < this.sortedQuestions.length; i++) {
        ids.push(this.sortedQuestions[i].id)
      }
      return ids
    },
  },
  methods: {
    reacticate(group) {
      this.sortedQuestions = group.questions
    },
    ...mapActions('products', ['selectProduct']),
    endDragQuestion(evt) {
      this.$emit('drag-question', evt.oldIndex, evt.newIndex)
    },
    onProductClick(product) {
      this.$emit('product-click', product)
    },
    onStageClick(question) {
      this.$emit('stage_click', question)
    },
  },
}
</script>
<style scoped lang="scss">
.questions {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  margin-top: 20px;

  @media (max-width: 767px) {
    justify-content: space-around;
  }

  &__card {
    max-width: 300px;
    height: 300px;
    margin: 5px;
    border: 1px solid #efefef;

    &:hover {
      border: 1px solid #f5ac49;
    }
  }
}
</style>
